// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { shuffle, splitList } from "@sequentech/ui-core";
import { checkIsCategoryList, checkIsExplicitBlankVote, checkIsInvalidVote, } from "./ElectionConfigService";
import { sortBy } from "lodash";
export var categorizeCandidates = function (question) {
    var enabledCandidates = question.candidates.filter(function (cand) { var _a, _b; return !((_b = (_a = cand.presentation) === null || _a === void 0 ? void 0 : _a.is_disabled) !== null && _b !== void 0 ? _b : false); });
    var isInvalidOrBlank = function (candidate) {
        return checkIsInvalidVote(candidate) || checkIsExplicitBlankVote(candidate);
    };
    var _a = splitList(enabledCandidates, isInvalidOrBlank), validCandidates = _a[0], invalidOrBlankCandidates = _a[1];
    var nonCategoryCandidates = [];
    var categoriesMap = {};
    for (var _i = 0, validCandidates_1 = validCandidates; _i < validCandidates_1.length; _i++) {
        var answer = validCandidates_1[_i];
        var category = answer.candidate_type;
        if (!category) {
            nonCategoryCandidates.push(answer);
            continue;
        }
        if (!categoriesMap[category]) {
            // initialize category
            categoriesMap[category] = {
                candidates: [],
            };
        }
        var isCategoryHeader = checkIsCategoryList(answer);
        if (isCategoryHeader) {
            categoriesMap[category].header = answer;
        }
        else {
            categoriesMap[category].candidates.push(answer);
        }
    }
    return {
        invalidOrBlankCandidates: invalidOrBlankCandidates,
        noCategoryCandidates: nonCategoryCandidates,
        categoriesMap: categoriesMap,
    };
};
export var getShuffledCategories = function (categories, shuffleAllOptions, shuffleCategories, shuffleCategoryList, types_presentation) {
    var shuffledCategories = {};
    var categoryKeys = shuffleCategories
        ? shuffle(Object.keys(categories))
        : sortBy(Object.keys(categories).map(function (key) {
            var _a, _b;
            return ({
                key: key,
                sort_order: (_b = (_a = types_presentation === null || types_presentation === void 0 ? void 0 : types_presentation[key]) === null || _a === void 0 ? void 0 : _a.sort_order) !== null && _b !== void 0 ? _b : 0,
            });
        }), "sort_order").map(function (value) { return value.key; });
    for (var _i = 0, categoryKeys_1 = categoryKeys; _i < categoryKeys_1.length; _i++) {
        var categoryKey = categoryKeys_1[_i];
        var category = categories[categoryKey];
        if (shuffleAllOptions || shuffleCategoryList.includes(categoryKey)) {
            category.candidates = shuffle(category.candidates);
        }
        shuffledCategories[categoryKey] = category;
    }
    return shuffledCategories;
};
